import { useState } from "react";
import moment from "moment";

export const useAllStockReport = (business) => {
  const [state, setState] = useState({
    isLoading: true,
    totalStockValue: 0,
    totalLowStockValue: 0,
    stockList: [],
    lowStockList: [],
    totalStockCount: 0,
    totalLowStockCount: 0,
    totalAllStocks: 0,
  });

  // Helpers
  const getDateRange = (filter) => {
    const start = moment(filter?.startDate || "20180101")
      .startOf("day")
      .valueOf();

    const end = filter?.endDate
      ? moment(filter.endDate).endOf("day").valueOf()
      : moment().endOf("day").valueOf();

    return { start, end };
  };

  const calculateStockStats = (items) => {
    let totalStockValue = 0;
    let totalLowStockValue = 0;
    let totalLowStockCount = 0;

    items.forEach((item) => {
      const stock = item.stock ?? 0;
      const price = item.cost_price ?? 0;

      if (stock && stock > 0) {
        totalStockValue += stock * price;
      }

      const lowStockLimit =
        item.low_stock !== null && item.low_stock !== undefined
          ? item.low_stock
          : 5;

      const isLowStock = stock <= lowStockLimit;

      if (isLowStock) {
        totalLowStockCount++;

        if (stock && stock > 0) {
          totalLowStockValue += stock * price;
        }
      }
    });

    return {
      totalStockValue,
      totalLowStockValue,
      totalLowStockCount,
    };
  };

  // Main Function
  const handleStock = async ({
    filter,
    limit,
    offset,
    isCalculateTotal = true,
  }) => {
    setState((prev) => ({ ...prev, isLoading: true }));

    const { start, end } = getDateRange(filter);

    try {
      let totals = {
        totalStockValue: state.totalStockValue,
        totalLowStockValue: state.totalLowStockValue,
        totalLowStockCount: state.totalLowStockCount,
        totalStockCount: state.totalStockCount,
        totalAllStocks: state.totalAllStocks,
      };

      // Calculate Totals
      if (isCalculateTotal) {
        const baseQuery = business.getUnarchivedStockByDateAndSearchText(
          start,
          end,
          filter
        );

        const rawStocks = await baseQuery.unsafeFetchRaw();

        const {
          totalStockValue,
          totalLowStockValue,
          totalLowStockCount,
        } = calculateStockStats(rawStocks);

        totals = {
          totalStockValue,
          totalLowStockValue,
          totalLowStockCount,
          totalStockCount: rawStocks.length,
          totalAllStocks: await business
            .getUnarchivedStockByDateAndSearchText(
              moment("20180101").startOf("day").valueOf(),
              moment().endOf("day").valueOf(),
              ""
            )
            .fetchCount(),
        };
      }

      // Paginated Data
      const paginatedStocks = await business
        .getUnarchivedStockByDateAndSearchText(
          start,
          end,
          filter,
          limit,
          offset
        )
        .fetch();

      const updatedStockList =
        offset > 0
          ? [...state.stockList, ...paginatedStocks]
          : paginatedStocks;

      // Update State
      setState((prev) => ({
        ...prev,
        isLoading: false,
        stockList: updatedStockList,
        ...totals,
      }));
    } catch (error) {
      console.error(error);
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  return { handleStock, ...state };
};